import { Route, Routes } from "react-router-dom";
import { ROUTE_PATHS } from "../constants/routeConstants";
import { Homepage } from "../Pages/User/Homepage";
import { BlogDetail } from "../Pages/User/BlogDetail";
import Blog from "../Pages/User/Blog";
import Contact from "../Pages/User/Contact";
import FAQ from "../Pages/User/FAQ";
import Brands from "../Pages/User/Brands";
import Products from "../Pages/User/Products";
import ProductSingle from "../Pages/User/ProductSingle";
import PrivacyPolicy from "../Pages/User/PrivacyPolicy";
import TermsAndConditions from "../Pages/User/TermsAndConditions";
import About from "../Pages/User/About";
import BusinessProfile from "../Pages/User/BusinessProfile";
import CategoryDetail from "../Pages/User/CategoryDetail";
import AllCategories from "../Pages/User/AllCategories";
import { NotFoundException } from "../exceptions/AppExceptions";
import { useEffect } from "react";
import { IMG_PLACEHOLDER } from "../Pages/User/components/Img";
import ScrollToTop from "../Components/ScrollToTop";

const ThrowNotFound = () => {
  throw new NotFoundException();
};

const UserRoutes = () => {
  useEffect(() => {
    document.body.addEventListener(
      "error",
      (event) => {
        if (event.target.tagName === "IMG") {
          // Images rendered with fallbackOnErr={false} opt out of placeholder swap.
          if (event.target.dataset.fallbackOnErr === "false") return;
          console.warn("An image failed to load:", event.target.src);
          event.target.src = IMG_PLACEHOLDER;
        }
      },
      true,
    );
  }, []);
  return (
    <>
      <ScrollToTop />
      <Routes>
      <Route path={ROUTE_PATHS.HOME} element={<Homepage />} />
      <Route path={ROUTE_PATHS.BLOG} element={<Blog />} />
      <Route path={ROUTE_PATHS.BLOG_DETAIL} element={<BlogDetail />} />
      <Route path={ROUTE_PATHS.CONTACT} element={<Contact />} />
      <Route path={ROUTE_PATHS.FAQ} element={<FAQ />} />
      <Route path={ROUTE_PATHS.BRANDS} element={<Brands />} />
      <Route path={ROUTE_PATHS.PRODUCTS} element={<Products />} />
      <Route path={ROUTE_PATHS.PRODUCTS_BY_SUBCATEGORY} element={<Products />} />
      <Route path={ROUTE_PATHS.PRODUCTS_BY_BRAND} element={<Products />} />
      <Route path={ROUTE_PATHS.PRODUCT_SINGLE} element={<ProductSingle />} />
      <Route path={ROUTE_PATHS.PRIVACY_POLICY} element={<PrivacyPolicy />} />
      <Route path={ROUTE_PATHS.TERMS} element={<TermsAndConditions />} />
      <Route path={ROUTE_PATHS.ABOUT} element={<About />} />
      <Route path={ROUTE_PATHS.BUSINESS_PROFILE} element={<BusinessProfile />} />
      <Route path={ROUTE_PATHS.CATEGORIES} element={<AllCategories />} />
      <Route path={ROUTE_PATHS.CATEGORY_DETAIL} element={<CategoryDetail />} />
      <Route path="*" element={<ThrowNotFound />} />
      </Routes>
    </>
  );
};

export default UserRoutes;
